import BoxCard from "shared/components/box/BoxCard.js";
import Count from "shared/components/counts/Count.js";
import { getOverallTag } from "shared/utils/player.js";

const MiscClubStats = ({ club }) => (
  <div className="d-flex flex-column flex-md-row flex-fill">
    <BoxCard
      className="mb-2 flex-md-basis-140"
      content={
        <div className="d-flex flex-fill mt-2 justify-content-center">
          <div className="d-flex flex-fill flex-column align-items-center justify-content-center">
            <Count label="MMR" count={club.mmr ? getOverallTag(club.mmr) : "None"} />
          </div>
        </div>
      }
    />
    <BoxCard
      className="mb-2 flex-md-basis-140"
      content={
        <div className="d-flex flex-fill mt-2 justify-content-center">
          <div className="d-flex flex-fill flex-column align-items-center justify-content-center">
            <Count label="Players" count={club.playerCount || "None"} />
          </div>
        </div>
      }
    />
    <BoxCard
      className="mb-2 flex-fill justify-content-center"
      content={
        <div className="row w-100 mt-2">
          <div className="col-6 col-sm-6 col-md-3 text-center mb-2 pt-2" style={{ lineHeight: 1.1 }}>
            {club.b11 || "None"}
            <br />
            <div className="text-secondary">B11</div>
          </div>
          <div className="col-6 col-sm-6 col-md-3 text-center mb-2 pt-2" style={{ lineHeight: 1.1 }}>
            {club.b11a ? getOverallTag(club.b11a) : "None"}
            <br />
            <div className="text-secondary">B11A</div>
          </div>
          <div className="col-6 col-sm-6 col-md-3 text-center pt-2" style={{ lineHeight: 1.1 }}>
            {club.ig11 ? getOverallTag(club.ig11) : "None"}
            <br />
            <div className="text-secondary">IG11</div>
          </div>
          <div className="col-6 col-sm-6 col-md-3 text-center pt-2" style={{ lineHeight: 1.1 }}>
            {club.b16a ? getOverallTag(club.b16a) : "None"}
            <br />
            <div className="text-secondary">B16A</div>
          </div>
        </div>
      }
    />
  </div>
);

export default MiscClubStats;
